import React, { useState } from "react";

const SupportNoticeModal = () => {
  const [visible, setVisible] = useState(true);

  if (!visible) return null;

  return (
    <div className="support-overlay">
      <div className="support-modal">
        <h1>
          <span className="support-alert-icon">🚨</span>
          Comunicado Importante
        </h1>

        <p>
          Comunicamos que o serviço Nuvem Fiscal será desativado em{" "}
          <strong>31/07/2026</strong>.
        </p>

        <p>
          Recomendamos que, dentro desse prazo, sejam adotadas as providências
          necessárias para migração ou contratação de solução alternativa
        </p>

        <p>
          Nossos canais de suporte permanecem à disposição para apoiá-los
          durante todo o processo de transição.
        </p>

        <div className="support-actions">
          <a href="/suporte" className="support-btn">
            Ver canais de suporte
          </a>

          <button className="support-close" onClick={() => setVisible(false)}>
            Entendi, fechar
          </button>
        </div>
      </div>

      <style>{`
        .support-overlay {
          position: fixed;
          inset: 0;
          background: rgba(0,0,0,0.55);
          z-index: 10000000000;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .support-modal {
          background: #fff;
          max-width: 720px;
          width: 90%;
          padding: 32px;
          border-radius: 10px;
          box-shadow: 0 20px 60px rgba(0,0,0,.25);
          color: #1f2937;
        }

        .support-modal h1 {
          display: flex;
          align-items: flex-start;
          gap: 14px;
          font-size: 1.8rem;
          line-height: 1.25;
          margin-bottom: 16px;
          color: #20283a;
          font-weight: 800;
        }

        .support-alert-icon {
          font-size: 1.55rem;
          line-height: 1.2;
          flex: 0 0 auto;
        }

        .support-modal p {
          color: #747b86;
          font-size: 1.05rem;
          line-height: 1.65;
          margin-bottom: 14px;
        }

        .support-modal h2 {
          display: flex;
          align-items: center;
          gap: 18px;
          margin-top: 22px;
          margin-bottom: 8px;
          color: #20283a;
          font-size: 3rem;
          line-height: 1.1;
          font-weight: 800;
        }

        .support-pin-icon {
          font-size: 2.4rem;
          flex: 0 0 auto;
        }

        .support-modal h3 {
          margin-top: 16px;
          margin-bottom: 8px;
          color: #20283a;
          font-size: 1.85rem;
          line-height: 1.25;
          font-weight: 800;
        }

        .support-modal ul {
          color: #747b86;
          font-size: 1rem;
          margin-bottom: 0;
          padding-left: 42px;
        }

        .support-actions {
          display: flex;
          align-items: center;
          gap: 6px;
          margin-top: 28px;
        }

        .support-btn {
          display: inline-block;
          padding: 14px 18px;
          background: #3156e8;
          color: #fff;
          border-radius: 4px;
          text-decoration: none;
          font-weight: 700;
        }

        .support-btn:hover {
          color: #fff;
          text-decoration: none;
          background: #2948c8;
        }

        .support-close {
          background: transparent;
          border: none;
          color: #666;
          cursor: pointer;
          font-size: 1rem;
          padding: 14px 0;
        }

        @media (max-width: 575px) {
          .support-modal {
            padding: 24px;
          }

          .support-modal h1 {
            font-size: 1.45rem;
          }

          .support-modal h2 {
            font-size: 2.2rem;
            gap: 12px;
          }

          .support-modal h3 {
            font-size: 1.45rem;
          }

          .support-actions {
            align-items: flex-start;
            flex-direction: column;
          }
        }
      `}</style>
    </div>
  );
};

export default SupportNoticeModal;
